import React, { useRef, useEffect, useState } from 'react';
import { BackendURL } from '../utils/BackendURL';
import axios from 'axios';
import OwlImage from '../Images/png-clipart-owl-emoji-tic-tac-toe-noto-fonts-emoticon-awesome-owl-emoji-smiley-owl.png'
import Pencil from '../Images/images.png'
import { useOnScreen } from '../assets/js/ContextProviders/OnScreenContext';

const EmployeeForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    mobileNumber: '',
    address: '',
    email: '',
    education: '',
    selectedPost: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [isFieldFocused, setIsFieldFocused] = useState(false);
  const [FocusedField, setFocusedField] = useState('');
  const handleFieldFocus = (name) => {
    setIsFieldFocused(true);
    setFocusedField(name)
  };

  const handleFieldBlur = () => {
    setIsFieldFocused(false);
    setFocusedField('')
  };

  function getCurrentRotation(divClass) {
    let el = document.querySelector(`.${divClass}`);
    let st = window.getComputedStyle(el, null);
    let tr = st.getPropertyValue("transform");
    let values = tr.split('(')[1].split(')')[0].split(',');
    let a = values[0];
    let b = values[1];
    let angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));

    // Ensure angle is positive
    if (angle < 0) {
      angle += 360;
    }
    return (angle);
  }

  useEffect(() => {
    const formPencil = document.querySelector(".form-Pencil")
    if (isFieldFocused) {
      const pencilRotation = getCurrentRotation('form-Pencil');
      if(pencilRotation != 345){
        formPencil.style.transform = `rotate(${pencilRotation}deg)`
        formPencil.style.transform = '';
        setTimeout(() => {
          formPencil.style.animation = 'translateAnimation 4s linear infinite';
        }, 500)
      }else{ 
        formPencil.style.animation = 'translateAnimation 4s linear infinite';
      }
      const eyeball = document.getElementsByClassName('owl-eyeball')
      for (let i = 0; i < eyeball.length; i++) {
        let FocusedFieldContent = formData[FocusedField].length
        let RotatingPixels = (FocusedFieldContent / 5)
        if (RotatingPixels < 4) {
          let X = RotatingPixels - 3
          // Min: eyeball[i].style.transform = 'translate(-3px , 2px)'
          // Max: eyeball[i].style.transform = 'translate(0px , 5px)'
          eyeball[i].style.transform = `translate(${X}px , ${X + 5}px)`
        } else {
          eyeball[i].style.transform = 'translate(0px , 5px)'
        }
      }
    } else {
      const pencilRotation = getCurrentRotation('form-Pencil')
      formPencil.style.animation = '';
      formPencil.style.transform = `rotate(${pencilRotation}deg)`
      setTimeout(() => {
        formPencil.style.transform = '';
      }, 100)
      const eyeball = document.getElementsByClassName('owl-eyeball')
      for (let i = 0; i < eyeball.length; i++) {
        eyeball[i].style.transform = 'translate(0px , 0px)'
      }
    }
  }, [isFieldFocused, FocusedField, formData])

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form Data:', formData);
    // You can send the data to a server or perform any other action here
    try {
      const res = await axios.post(`${BackendURL}/jobs-cvs`, formData);
      console.log(res.data);
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  const { isOnScreen, DivScreenRef, checkIfOnScreen } = useOnScreen();
  useEffect(() => {
    checkIfOnScreen();

    const handleScroll = () => {
      checkIfOnScreen();
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const Owl = document.querySelector('.form-owlimg')
    if (isOnScreen) {
      Owl.classList.add('form-owlimg-position');
    } else {
      Owl.classList.remove('form-owlimg-position');
    }
  }, [isOnScreen])


  function input(name) {
    return (
      <input
        type="text"
        name={name}
        value={formData.name}
        onChange={handleChange}
        onFocus={(e) => handleFieldFocus(e.target.name)}
        onBlur={(e) => handleFieldBlur(e.target.name)}
      />
    )
  }

  return (
    <form className="employee-form" onSubmit={handleSubmit} ref={DivScreenRef}>
      <label>
        <div className="employ-label-heading">First Name:</div>
        {input('firstName')}
      </label>

      <label>
        <div className="employ-label-heading">Last Name:</div>
        {input('lastName')}
      </label>

      <label>
        <div className="employ-label-heading">Mobile Number:</div>
        {input('mobileNumber')}
      </label>

      <label>
        <div className="employ-label-heading">Address:</div>
        {input('address')}
      </label>

      <label>
        <div className="employ-label-heading">Email:</div>
        {input('email')}
      </label>

      <label>
        <div className="employ-label-heading">Education:</div>
        {input('education')}
      </label>

      <label>
        <div className="employ-label-heading">Select Post:</div>
        <select
          name="selectedPost"
          value={formData.selectedPost}
          onChange={handleChange}
        >
          <option value="">Select Post</option>
          <option value="Shift Incharge">Shift Incharge</option>
          <option value="Pharmacist">Pharmacist</option>
          <option value="SaleMan">SaleMan</option>
          <option value="Helper">Helper</option>
          <option value="Branch Manager">Branch Manager</option>
        </select>
      </label>

      <div className="employ-submit-row flex">
        <button type="submit" className="submit-button">Submit</button>
      </div>

      <div className="form-owlimg">
        <img src={OwlImage} className='form-OwlImage-img' alt="" />
        <img src={Pencil} className='form-Pencil' alt="" />
        <div className="Owl-eyes">
          <div className="OwlEye flex">
            <div className="owl-eyeball"></div>
          </div>
          <div className="OwlEye flex">
            <div className="owl-eyeball"></div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default EmployeeForm;


